import {
    DestinationEvent,
    UrgencySignalsKeys,
} from '@eventbrite/event-renderer';

export interface RawData {
    isAuthenticated: boolean;
    currencyFormat: string;
    eventData: DestinationEvent;
}

export const EVENT_CARD_DATA: RawData = {
    isAuthenticated: true,
    currencyFormat: '¤#,##0.00',
    eventData: {
        image: {
            edge_color_set: true,
            edge_color: '#0f0b08',
            url: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&q=5&w=3600&h=1800&fit=crop&fm=jpg',
            original: {
                url: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&q=5&w=3600&h=1800&fit=crop&fm=jpg',
                width: 3600,
                height: 1800,
            },
            crop_mask: {
                width: 3600,
                height: 1800,
                top_left: {
                    y: 308,
                    x: 0,
                },
            },
            aspect_ratio: '2',
            id: '142835829',
        },
        event_sales_status: {
            default_message: null,
            sales_status: 'on_sale',
            message_code: null,
            message: null,
            message_type: null,
        },
        timezone: 'America/New_York',
        id: '165032684201',
        tickets_url:
            'https://www.evbdev.com/checkout-external?eid=165032684201',
        urgency_signals: {
            messages: [UrgencySignalsKeys.salesEndSoon],
            categories: [],
        },
        tickets_by: 'Eventbrite',
        primary_organizer_id: '30829724919',
        dedup: {
            count: 1,
            hash: '',
        },
        num_children: 14,
        debug_info: {},
        parent_url:
            'https://www.evbdev.com/e/small-group-east-village-culinary-journey-tickets-165032429439',
        hide_end_date: false,
        start_date: '2023-09-30',
        end_time: '18:00',
        _type: 'destination_event',
        ticket_availability: {
            is_sold_out: false,
            is_free: false,
            minimum_ticket_price: {
                currency: 'USD',
                major_value: '99.00',
                value: 9900,
                display: '99.00 USD',
            },
            has_available_tickets: true,
            maximum_ticket_price: {
                currency: 'USD',
                major_value: '99.00',
                value: 9900,
                display: '99.00 USD',
            },
        },
        end_date: '2023-09-30',
        tags: [
            {
                prefix: 'EventbriteSubCategory',
                tag: 'EventbriteSubCategory/10003',
                display_name: 'Food',
            },
            {
                prefix: 'EventbriteCategory',
                tag: 'EventbriteCategory/110',
                display_name: 'Food & Drink',
                localized: {
                    display_name: 'Food & Drink',
                },
            },
            {
                prefix: 'EventbriteFormat',
                tag: 'EventbriteFormat/16',
                display_name: 'Tour',
            },
        ],
        eventbrite_event_id: '165032684201',
        start_time: '15:00',
        primary_venue: {
            _type: 'destination_venue',
            name: 'Meeting Location -',
            address: {
                city: 'New York',
                country: 'US',
                region: 'NY',
                longitude: '-73.98153370000001',
                localized_address_display:
                    'https://avitaltours.com/nyc-food-tours/east-village-food-tour-meeting-locations/, New York, NY 10003',
                postal_code: '10003',
                address_1:
                    'https://avitaltours.com/nyc-food-tours/east-village-food-tour-meeting-locations/',
                latitude: '40.7264773',
                localized_multi_line_address_display: [
                    'https://avitaltours.com/nyc-food-tours/east-village-food-tour-meeting-locations/',
                    'New York, NY 10003',
                ],
                localized_area_display: 'New York, NY',
            },
            id: '62292023',
        },
        primary_organizer: {
            _type: 'destination_profile',
            num_upcoming_events: null,
            name: 'Avital: Tours',
            profile_type: 'organizer',
            num_followers: 0,
            url: 'https://www.evbdev.com/o/avital-tours-30829724919',
            twitter: 'AvitalTours',
            summary:
                'Avital Events has spent the last 10 years designing award-winning culinary experiences. Our Virtual Culinary Events are live, interactive cooking and cocktail video experiences. Get hands-on and engag...',
            num_saves: null,
            image_id: '107485835',
            followed_by_you: false,
            facebook: 'AvitalTours',
            num_collections: null,
            id: '30829724919',
            website_url: 'https://avitaltours.com/',
            num_following: null,
        },
        image_id: '142835829',
        is_protected_event: false,
        is_cancelled: null,
        primary_venue_id: '62292023',
        checkout_flow: 'widget',
        series_id: '165032429439',
        name: 'Small Group East Village Culinary Journey',
        language: 'en-us',
        url: 'https://www.evbdev.com/e/small-group-east-village-culinary-journey-tickets-165032684201',
        hide_start_date: false,
        summary:
            'Our East Village, NYC Food Tour showcases the ethnic cuisines and culture that makes this one of the most diverse eating grounds in NYC!',
        is_online_event: false,
        eid: '165032684201',
        published: '2021-07-27T18:58:21Z',
    },
};
